/** A soft wash of a palette colour, e.g. tint('success-main', 12). */
export const tint = (token: string, percent: number) => `color-mix(in srgb, var(--mui-palette-${token}) ${percent}%, transparent)`;

/** The white, hairline-bordered column surface. */
export const panelSx = {
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'divider',
  borderRadius: 1.5,
  overflow: 'hidden',
} as const;

export const tagSx = {
  display: 'inline-flex',
  alignItems: 'center',
  px: 0.75,
  py: 0.25,
  borderRadius: 0.75,
  bgcolor: 'surface.sunken',
  color: 'text.secondary',
  fontSize: '0.6875rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
} as const;

export const countSx = {
  minWidth: 20,
  height: 20,
  px: 0.5,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 1,
  bgcolor: 'surface.sunken',
  color: 'text.secondary',
  fontSize: '0.6875rem',
  fontWeight: 600,
  flexShrink: 0,
} as const;

export const outlineButtonSx = { color: 'text.primary', borderColor: 'divider', bgcolor: 'background.paper' } as const;

export const enterSx = {
  '@keyframes subIn': { from: { opacity: 0, transform: 'translateY(4px)' }, to: { opacity: 1, transform: 'none' } },
  animation: 'subIn 220ms ease-out both',
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
} as const;
